module.exports = __webpack_public_path__ + "img/account-group.4ea9efde.svg";